import { render, staticRenderFns } from "./GlassMoveQrForm.vue?vue&type=template&id=bac7dcc4&scoped=true&"
import script from "./GlassMoveQrForm.vue?vue&type=script&lang=js&"
export * from "./GlassMoveQrForm.vue?vue&type=script&lang=js&"
import style0 from "./GlassMoveQrForm.vue?vue&type=style&index=0&id=bac7dcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac7dcc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VChip,VDivider,VSelect})
